import { NoteType , SystemLogType, SmsDirection} from '@prisma/client'
export enum ActivityFeedRequires {
  CONTACT = 'CONTACT',
  BUSINESS = 'BUSINESS',
  CONTACT_AND_BUSINESS = 'CONTACT_AND_BUSINESS',
  ALL_BUSINESSES = 'ALL_BUSINESSES',
}


export const NoteTypeIcon: Record<NoteType, string> = {
  [NoteType.Note]: 'mdi:note-text-outline',
  [NoteType.Call]: 'mdi:phone-outline',
  [NoteType.Email]: 'mdi:email-outline',
  [NoteType.SMS]: 'mdi:message-text-outline',
  [NoteType.Inspection]: 'mdi:eye-outline',
  [NoteType.Offer]: 'mdi:currency-usd',
  [NoteType.Meeting]: 'mdi:calendar-clock',
  [NoteType.EmailSyncReceived]: 'mdi:email-receive-outline',
  [NoteType.EmailSyncSent]: 'mdi:email-send-outline',
}


export const NoteTypeName: Record<NoteType, string> = {
  [NoteType.Note]: 'Note',
  [NoteType.Call]: 'Call',
  [NoteType.Email]: 'Email',
  [NoteType.SMS]: 'SMS',
  [NoteType.Inspection]: 'Inspection',
  [NoteType.Offer]: 'Offer',
  [NoteType.Meeting]: 'Meeting',
  [NoteType.EmailSyncReceived]: 'Email Sync Received',
  [NoteType.EmailSyncSent]: 'Email Sync Sent',
}


export const NoteTypeColor: Record<NoteType, string> = {
  [NoteType.Note]: 'blue',
  [NoteType.Call]: 'cyan',
  [NoteType.Email]: 'purple',
  [NoteType.SMS]: 'yellow',
  [NoteType.Inspection]: 'orange',
  [NoteType.Offer]: 'lime',
  [NoteType.Meeting]: 'indigo',
  [NoteType.EmailSyncReceived]: 'green',
  [NoteType.EmailSyncSent]: 'red',
}


export const NoteTitleFormat: Record<NoteType, string> = {
  [NoteType.Note]: 'Note added by [USER_NAME]',
  [NoteType.Call]: 'Call logged by [USER_NAME]',
  [NoteType.Email]: 'Email logged by [USER_NAME]',
  [NoteType.SMS]: 'SMS logged by [USER_NAME]',
  [NoteType.Inspection]: 'Inspection scheduled by [USER_NAME]',
  [NoteType.Offer]: 'Offer recorded by [USER_NAME]',
  [NoteType.Meeting]: 'Meeting scheduled by [USER_NAME]',
  [NoteType.EmailSyncReceived]: 'Email received from [USER_NAME]',
  [NoteType.EmailSyncSent]: 'Email sent by [USER_NAME]',
}

export const SystemLogTypeIcon: Record<SystemLogType, string> = {
  [SystemLogType.CA_INVITE_SENT]: 'mdi:email-send-outline',
  [SystemLogType.NDA_COMPLETED]: 'mdi:file-pdf-outline',
  [SystemLogType.ACCESS_UPDATED]: 'mdi:key-outline',
  [SystemLogType.INTEREST_STATUS_CHANGED]: 'mdi:star-outline',
  [SystemLogType.FILE_VIEWED]: 'mdi:file-eye-outline',
  [SystemLogType.FILE_DOWNLOADED]: 'mdi:file-download-outline',
  [SystemLogType.FILE_ACCESS_REQUESTED]: 'mdi:file-question-outline',
}

export const SystemLogTypeName: Record<SystemLogType, string> = {
  [SystemLogType.CA_INVITE_SENT]: 'Client Access Invite Sent',
  [SystemLogType.NDA_COMPLETED]: 'NDA Completed',
  [SystemLogType.ACCESS_UPDATED]: 'Access Updated',
  [SystemLogType.INTEREST_STATUS_CHANGED]: 'Interest Status Changed',
  [SystemLogType.FILE_VIEWED]: 'File Viewed',
  [SystemLogType.FILE_DOWNLOADED]: 'File Downloaded',
  [SystemLogType.FILE_ACCESS_REQUESTED]: 'File Access Requested',
}

export const SystemLogTypeColor: Record<SystemLogType, string> = {
  [SystemLogType.CA_INVITE_SENT]: 'blue',
  [SystemLogType.NDA_COMPLETED]: 'emerald',
  [SystemLogType.ACCESS_UPDATED]: 'indigo',
  [SystemLogType.INTEREST_STATUS_CHANGED]: 'yellow',
  [SystemLogType.FILE_VIEWED]: 'cyan',
  [SystemLogType.FILE_DOWNLOADED]: 'green',
  [SystemLogType.FILE_ACCESS_REQUESTED]: 'amber',
}

export const SmsDirectionIcon: Record<SmsDirection, string> = {
  [SmsDirection.OUTBOUND]: 'mdi:message-arrow-right-outline',
  [SmsDirection.INBOUND]: 'mdi:message-arrow-left-outline',
}

export const SmsDirectionName: Record<SmsDirection, string> = {
  [SmsDirection.OUTBOUND]: 'SMS Sent',
  [SmsDirection.INBOUND]: 'SMS Received',
}

export const SmsDirectionColor: Record<SmsDirection, string> = {
  [SmsDirection.OUTBOUND]: 'orange',
  [SmsDirection.INBOUND]: 'green',
}
